import { useEffect } from "react";
import { log } from "../monitoring/log";

type JquerySelectorOrElement = string | HTMLElement;
interface JQueryResult {
  on(event: string, handler: (event: any) => void): JQueryResult;
  off(event: string, handler: (event: any) => void): JQueryResult;
}
type JQueryFn = (element: JquerySelectorOrElement) => JQueryResult;

const isJquery = ($: unknown): $ is JQueryFn => {
  if (typeof $ === "function" && "ajax" in $ && typeof $.ajax === "function") {
    return true;
  }
  return false;
};

export const useJqueryEventListener = (
  element: JquerySelectorOrElement,
  events: string | string[],
  callback: (event: any) => void,
): void => {
  useEffect(() => {
    try {
      // TODO: Should re-trigger this effect if $ or jQuery is undefined to start.

      const $ = globalThis.$ || globalThis.jQuery;

      if (!isJquery($)) {
        return;
      }

      for (const event of Array.isArray(events) ? events : [events]) {
        $(element).on(event, callback);
      }
    } catch (err) {
      log("Error adding jquery event listener", err);
    }

    return () => {
      try {
        const $ = globalThis.$ || globalThis.jQuery;

        if (!isJquery($)) {
          return;
        }

        for (const event of Array.isArray(events) ? events : [events]) {
          $(element).off(event, callback);
        }
      } catch (err) {
        log("Error removing jquery event listener", err);
      }
    };
  }, [element, events, callback]);
};
